import { render } from "./StateSanierungWand.vue?vue&type=template&id=c2215a8c"
import script from "./StateSanierungWand.vue?vue&type=script&lang=js"
export * from "./StateSanierungWand.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vattenfall\\vattenfall-klickstrecke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__